import React from 'react';
import { Edit, Flag } from '@mui/icons-material';
import { Box, Typography, Tooltip, useMediaQuery } from '@mui/material';
import { priorityColor } from '../utility/utilities';
import bug from '../../../assets/Gifs/search.gif';
import other from '../../../assets/Gifs/other.gif';
import feature from '../../../assets/Gifs/process.gif';
import { variants } from '../../../variants/variants';

const gif = {
  'bug report': bug,
  other: other,
  'feature request': feature,
};

const ChatBubble = ({ isOwnMessage, feedback }) => {
  const { feedbackText, edited } = feedback;
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          borderRadius: 3,
          backgroundColor: '#EEF5FF',
          padding: '8px 12px',
          width: { xs: '65vw', lg: '30vw' },
          maxWidth: '100%',
          wordWrap: 'break-word',
          marginLeft: 0,
          marginRight: 'auto',
          boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        {!isMobile ? null : (
          <img
            src={gif[feedback.category]}
            style={{
              position: 'absolute',
              top: 30,
              left: 'calc(-35px)',
              height: 30,
              width: 30,
              transform: 'translateY(-20px)',
            }}
          />
        )}
        <Tooltip title={`Priority flag: ${feedback.priority}`}>
          <Flag
            sx={{
              position: 'absolute',
              right: 'calc(-20px)',
              color: priorityColor(feedback.priority),
              fontSize: '13px',
              transform: 'translateY(5px)',
            }}
          />
        </Tooltip>

        {edited && (
          <Tooltip title="This feedback has been edited">
            <Edit
              sx={{
                position: 'absolute',
                right: 'calc(-40px)',
                color: 'grey',
                fontSize: '13px',
                transform: 'translateY(5px)',
              }}
            />
          </Tooltip>
        )}

        <Typography
          variant="body1"
          color={'black'}
          fontSize={variants.BODY}
          sx={{
            whiteSpace: 'pre-wrap',
            '& a': {
              color: 'black',
            },
          }}
          dangerouslySetInnerHTML={{ __html: feedbackText }}
        />
      </Box>
    </Box>
  );
};

export default ChatBubble;
